// ControlFilterInputFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import FilterInputControlView  from 'report/FilterInputControlView.js';


//=============================================================================
//
// Creates one of five kinds of text control, given a factoryService
// parameter key and a layout postion. The factory key defines the 
// control appearance through its template. It defines the  initial rectangle
// of the control via a width and height from the factory parameter.
//
// -Rene Lopez, 09/09/2016
//
//=============================================================================
class ControlFilterInputFactory extends BaseVisualControlFactory {

	constructor () {
		super();
	}

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes( factoryKey, pos ) ;
  		//adding silent(accessibility) to attributes.
  		attributes.silent = false;
		attributes.styleColorText = '~textColor';
		attributes.fontFamily = '~inputFont';
		attributes.fontSize = '~textFont';
		attributes.textWeight = '~textFont';
		attributes.textStyle = '~textFont';
		attributes.borderSize = '~inputBorder';
		attributes.borderStyle = '~inputBorder';
		attributes.borderColor = '#000000';
		attributes.sharedSettingsTitle = 'Filter Input Shared Settings';
		attributes.tabSettingsTitle = 'Filter Input Settings';
		attributes.type='text';
		attributes.operator='equal';
		attributes.align='left';
		attributes.cornerRadius = '2';
		attributes.Columns = { Column: [{id:'0', Properties: {
			usesExpression: "false",
			formatoption: "",
			fieldId: "",
			width: "150",
			format: "none",
			caption: "",
			sortType: "none",
			visible: "true",
			setDynamicFilter: "false",
			align: "left",
			aggregation: "group",
			fieldDataType: "",
			sortOrder: "0"
		}}] };
        attributes.resizePadding = 2;
		attributes.minWidth = 75;
		attributes.lowestHeight = 15;
		this.resolveForInitialMinHeight(attributes);
		
		attributes.text1 = '';
		attributes.respectDynamicFilter = 'true';
		attributes.setDynamicFilter = 'true';
		attributes.text2 = '';
		attributes.additiveDynamicFilter = 'true'; 

        const view = new FilterInputControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            							pos: pos, factoryKey: factoryKey, id:attributes.id} );

		return view;
	}

}

const controlFilterInputFactory = new ControlFilterInputFactory();

export default controlFilterInputFactory;
